"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElementsByAnalticsClass = exports.logEvent = exports.setUserProperty = exports.initAmplitude = void 0;
const amplitudeClient = require("@amplitude/analytics-browser");
const constants_1 = require("../constants");
const common_1 = require("../utils/common");
const jwt_decode_1 = require("jwt-decode");
function initAmplitude() {
    let userLoginStatus = constants_1.GA4_NOT_LOGGED_IN;
    const sessionCookie = (0, common_1.getCookie)("__session");
    const wordtuneCookie = (0, common_1.getCookie)("wordtuneToken");
    const AMPLITUDE_API_KEY = (0, common_1.isStaging)()
        ? "7351ccfe21b4f05f4fb741d097ba8737"
        : "64be6fdb8aeb001529c8c2c9af7028a0";
    let userDeviceId = amplitudeClient === null || amplitudeClient === void 0 ? void 0 : amplitudeClient.getDeviceId();
    if (userDeviceId) {
        console.log("lp-existing device id: ", userDeviceId);
        return;
    }
    let wordtuneUserId = undefined;
    if (sessionCookie) {
        try {
            const decodedSessionCookie = (0, jwt_decode_1.default)(sessionCookie);
            wordtuneUserId = decodedSessionCookie.wordtune_user_id;
        }
        catch (error) {
            console.error("Error decoding session cookie", error);
        }
    }
    const deviceId = (0, common_1.getCookie)(constants_1.DEVICE_ID_COOKIE_NAME);
    const isDeviceIdValid = deviceId && (deviceId === null || deviceId === void 0 ? void 0 : deviceId.length) > 10;
    amplitudeClient
        .init(AMPLITUDE_API_KEY, {
        defaultTracking: false,
        // if deviceId is undefined amplitude will generate a new one
        deviceId: isDeviceIdValid ? deviceId : undefined,
        userId: wordtuneUserId,
    })
        .promise.then(function (result) {
        userDeviceId = amplitudeClient === null || amplitudeClient === void 0 ? void 0 : amplitudeClient.getDeviceId();
        (0, common_1.updateCookie)({ lpDeviceId: userDeviceId });
        // create a cookie with the device id
        // or refresh the cookie expiration if it already exists
        // in order to keep the device id for 400 days from the last visit
        window.document.cookie = `${constants_1.DEVICE_ID_COOKIE_NAME}=${userDeviceId}; max-age=${constants_1.DEVICE_ID_COOKIE_EXPIRATION}; path=/; domain=${(0, common_1.isStaging)() ? ".wordtune-stg.com" : ".wordtune.com"}; samesite=none; secure`;
    });
    if (sessionCookie) {
        let token = (0, jwt_decode_1.default)(sessionCookie);
        sendWebAppPageEnteredToGoogleAnalytics(constants_1.GA4_LOGGED_IN, token["user_id"], getPlanType(token["read_plan_type"], token["plan_type"]));
    }
    else if (wordtuneCookie) {
        const anonymousToken = (0, jwt_decode_1.default)(wordtuneCookie);
        sendWebAppPageEnteredToGoogleAnalytics(constants_1.GA4_ANONYMOUS, anonymousToken["user_id"], anonymousToken["plan_type"]);
    }
    else {
        sendWebAppPageEnteredToGoogleAnalytics(userLoginStatus, null, null);
    }
    window.addEventListener("pagehide", () => {
        // Set https transport to use sendBeacon API
        amplitudeClient.setTransport("beacon");
        // Send all pending events to server
        amplitudeClient.flush();
    });
}
exports.initAmplitude = initAmplitude;
function setUserProperty(key, value) {
    const identify = new amplitudeClient.Identify().set(key, value);
    amplitudeClient.identify(identify);
}
exports.setUserProperty = setUserProperty;
async function logEvent(type, props) {
    try {
        initAmplitude();
        const urlParams = (0, common_1.getUrlParams)();
        amplitudeClient.track(type, {
            ...props,
            ...urlParams,
            app: constants_1.APP_NAME,
            host: window.location.hostname,
            path: window.location.pathname,
        });
    }
    catch (e) {
        console.log("%cerror", "color: red; font-size: xx-large", e);
    }
}
exports.logEvent = logEvent;
function getElementsByAnalticsClass() {
    return document.getElementsByClassName("analytics");
}
exports.getElementsByAnalticsClass = getElementsByAnalticsClass;
function sendWebAppPageEnteredToGoogleAnalytics(userLoginStatus, userID, userPlan) {
    window.dataLayer.push({
        userLoginStatus: userLoginStatus,
        userID: userID,
        userPlan: userPlan,
        siteType: constants_1.GA4_EVENT_SITE_TYPE,
        event: constants_1.GA4_EVENT,
    });
}
function getPlanType(writePlanType, readPlanType) {
    return readPlanType === "free" ? writePlanType : readPlanType;
}
